/* NOVAIRE image hero — scroll-story driver ported from the "Shopify Hero"
   design mockup: rAF-throttled scroll progress across the tall track drives
   the artwork fade-in (0–0.3), the first screen's lift-away (0.32–0.55),
   the glass scrim + second screen's arrival (0.6–0.85, scrim ×0.9), and the
   scroll hint fade (gone by 0.12). Smoothstep easing throughout. Skipped
   under reduced motion (CSS renders the static fallback). */
(function () {
  'use strict';

  function initSection(sec) {
    if (sec.hasAttribute('data-nv-shero-init')) return;
    sec.setAttribute('data-nv-shero-init', '');

    var bgWrap = sec.querySelector('[data-nv-shero-bg]');
    var bg = bgWrap && (bgWrap.querySelector('img') || bgWrap.querySelector('video'));
    var scrim = sec.querySelector('[data-nv-shero-scrim]');
    var one = sec.querySelector('[data-nv-shero-screen="1"]');
    var two = sec.querySelector('[data-nv-shero-screen="2"]');
    var hint = sec.querySelector('[data-nv-shero-hint]');
    if (!bg || !one) return;

    function ramp(p, a, b) {
      return Math.min(1, Math.max(0, (p - a) / (b - a)));
    }
    function ease(t) {
      return t * t * (3 - 2 * t);
    }

    var raf = 0;
    function update() {
      var rect = sec.getBoundingClientRect();
      var total = Math.max(1, rect.height - window.innerHeight);
      var p = Math.min(1, Math.max(0, -rect.top / total));

      var img = ease(ramp(p, 0.0, 0.3));
      var out = ease(ramp(p, 0.32, 0.55));
      var inn = ease(ramp(p, 0.6, 0.85));

      bg.style.opacity = img;
      if (scrim) scrim.style.opacity = 0.9 * inn;
      one.style.opacity = 1 - out;
      one.style.transform = 'translateY(' + (-110 * out) + 'px)';
      one.style.pointerEvents = out > 0.5 ? 'none' : 'auto';
      one.setAttribute('aria-hidden', out > 0.5 ? 'true' : 'false');
      one.inert = out > 0.5;
      if (two) {
        two.style.opacity = inn;
        two.style.transform = 'translateY(' + (36 * (1 - inn)) + 'px)';
        two.style.pointerEvents = inn > 0.5 ? 'auto' : 'none';
        two.setAttribute('aria-hidden', inn > 0.5 ? 'false' : 'true');
        two.inert = inn <= 0.5;
      }
      if (hint) hint.style.opacity = Math.max(0, 1 - p / 0.12);
    }

    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-nv-shero-enabled]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  /* Theme editor: selecting a block scrolls the runway to its screen's band. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (e) {
      var screen = e.target && e.target.closest && e.target.closest('[data-nv-shero-screen]');
      if (!screen) return;
      var sec = screen.closest('[data-nv-shero-enabled]');
      if (!sec) return;
      var total = sec.offsetHeight - window.innerHeight;
      if (total <= 0) return;
      var band = screen.getAttribute('data-nv-shero-screen') === '2' ? 0.75 : 0.1;
      var top = sec.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: top + band * total, behavior: 'smooth' });
    });
  }
})();
